export const OEMFilter: {
	[key: string]: {
		en: string
		th: string
		value: any
	}
} = {
	all: {
		en: 'All',
		th: 'ทั้งหมด',
		value: 'all',
	},
	new: {
		en: 'New Inquiries',
		th: 'คำร้องใหม่',
		value: 'newRequest',
	},
	send: {
		en: 'Quotation Sent',
		th: 'ส่งใบเสนอราคาแล้ว',
		value: 'quoted',
	},
	confirmed: {
		en: 'Quotation Confirmed',
		th: 'ยืนยันใบเสนอราคาแล้ว',
		value: 'quoted',
	},
	payment: {
		en: 'Payment Completed',
		th: 'ชำระเงินแล้ว',
		value: 'paymentCompleted',
	},
	sampleApproved: {
		en: 'Sample Approved',
		th: 'ยืนยันตัวอย่างแล้ว',
		value: 'sampleApproved',
	},
	inProduction: {
		en: 'In Production',
		th: 'กำลังเดินการผลิต',
		value: 'inProduction',
	},
	delivered: {
		en: 'Delivered',
		th: 'จัดส่งแล้ว',
		value: 'delivered',
	},
	completed: {
		en: 'Transaction Completed',
		th: 'จัดส่งสำเร็จ',
		value: 'completed',
	},
	cancel: {
		en: 'Canceled',
		th: 'ยกเลิก',
		value: 'cancelled',
	},
	dispute: {
		en: 'Disputed',
		th: 'ข้อพิพาท',
		value: 'dispute',
	},
}
